const axios = require('axios');

export const getLeaderboard = function () {

    var leaderboardData;
    var url = document.getElementById("urlId").value;
    var leaderboardUrl = document.getElementById("leaderboardUrl").value;
    var zeroCards = document.getElementsByClassName("zero-column-cards");
    var firstCards = document.getElementsByClassName("first-column-cards");
    var secondCards = document.getElementsByClassName("second-column-cards");
    var thirdCards = document.getElementsByClassName("third-column-cards");
    var fourthCards = document.getElementsByClassName("fourth-column-cards");
    var winnerCard = document.getElementsByClassName("winner-card");
    var zeroCardsMobile = document.getElementsByClassName("mobile-zero-column-cards");
    var firstCardsMobile = document.getElementsByClassName("mobile-first-column-cards");
    var secondCardsMobile = document.getElementsByClassName("mobile-second-column-cards");
    var thirdCardsMobile = document.getElementsByClassName("mobile-third-column-cards");
    var fourthCardsMobile = document.getElementsByClassName("mobile-fourth-column-cards");
    var winnerCardMobile = document.getElementsByClassName("mobile-winner-card");

    axios({
        method: 'get',
        url: url,
        //url: 'https://thenegotiators.thenegotiationsociety.com/api/LeaderBoard',
        responseType: 'json'
    })
        .then(function (response) {
            leaderboardData = response.data;

            if(leaderboardData.length<=1 && leaderboardUrl.length<=1)
            {
                window.location=leaderboardUrl;
            }

            //Zero Column
            //We go through every competitor one by one
            for (var competitor = 0; competitor < leaderboardData.length ; competitor++) {

                //We go through every card in the zero column one by one
                for (var card = 0; card < 32; card++) {

                    //If we find that the competitor's zero column position
                    //is the card's position we are iterating right now, then we enter.
                    if (leaderboardData[competitor].level5 === (card + 1)) {

                        //Changing the card's position number, flag and name to our competitor's.
                        zeroCards[card].querySelector("img").src = `/assets/image/flags/1x1/${leaderboardData[competitor].countryCode.toLowerCase()}.svg`
                        zeroCards[card].querySelector(".competitor-name").innerHTML = leaderboardData[competitor].name;
                        zeroCardsMobile[card].querySelector("img").src = `/assets/image/flags/1x1/${leaderboardData[competitor].countryCode.toLowerCase()}.svg`
                        zeroCardsMobile[card].querySelector(".competitor-name").innerHTML = leaderboardData[competitor].name;
                    }
                }
            }

            //First Column
            //We go through every competitor one by one
            for (competitor = 0; competitor < leaderboardData.length ; competitor++) {

                //We go through every card in the first column one by one
                for (card = 0; card < 16; card++) {

                    //If we find that the competitor's first column position
                    //is the card's position we are iterating right now, then we enter.
                    if (leaderboardData[competitor].level4 === (card + 1)) {

                        //Changing the card's position number, flag and name to our competitor's.
                        firstCards[card].querySelector("img").src = `/assets/image/flags/1x1/${leaderboardData[competitor].countryCode.toLowerCase()}.svg`
                        firstCards[card].querySelector(".competitor-name").innerHTML = leaderboardData[competitor].name;
                        firstCardsMobile[card].querySelector("img").src = `/assets/image/flags/1x1/${leaderboardData[competitor].countryCode.toLowerCase()}.svg`
                        firstCardsMobile[card].querySelector(".competitor-name").innerHTML = leaderboardData[competitor].name;
                    }
                }
            }

            //Second Column
            for (competitor = 0; competitor < leaderboardData.length ; competitor++) {

                //We go through every card in the second column one by one
                for (card = 0; card < 8; card++) {

                    //If we find that the competitor's second column position
                    //is the card's position we are iterating right now, then we enter.
                    if (leaderboardData[competitor].level3 === (card + 1)) {

                        //Changing the card's position number, flag and name to our competitor's.
                        secondCards[card].querySelector("img").src = `/assets/image/flags/1x1/${leaderboardData[competitor].countryCode.toLowerCase()}.svg`
                        secondCards[card].querySelector(".competitor-name").innerHTML = leaderboardData[competitor].name;
                        secondCardsMobile[card].querySelector("img").src = `/assets/image/flags/1x1/${leaderboardData[competitor].countryCode.toLowerCase()}.svg`
                        secondCardsMobile[card].querySelector(".competitor-name").innerHTML = leaderboardData[competitor].name;
                    }
                }
            }

            //Third Column
            for (competitor = 0; competitor < leaderboardData.length ; competitor++) {

                //We go through every card in the third column one by one
                for (card = 0; card < 8; card++) {

                    //If we find that the competitor's third column position
                    //is the card's position we are iterating right now, then we enter.
                    if (leaderboardData[competitor].level2 === (card + 1)) {

                        //Changing the card's position number, flag and name to our competitor's.
                        thirdCards[card].querySelector("img").src = `/assets/image/flags/1x1/${leaderboardData[competitor].countryCode.toLowerCase()}.svg`
                        thirdCards[card].querySelector(".competitor-name").innerHTML = leaderboardData[competitor].name;
                        thirdCardsMobile[card].querySelector("img").src = `/assets/image/flags/1x1/${leaderboardData[competitor].countryCode.toLowerCase()}.svg`
                        thirdCardsMobile[card].querySelector(".competitor-name").innerHTML = leaderboardData[competitor].name;
                    }
                }
            }

            //Fourth Column
            for (competitor = 0; competitor < leaderboardData.length ; competitor++) {

                //We go through every card in the fourth column one by one
                for (card = 0; card < 8; card++) {

                    //If we find that the competitor's fourth column position
                    //is the card's position we are iterating right now, then we enter.
                    if (leaderboardData[competitor].level1 === (card + 1)) {

                        //Changing the card's position number, flag and name to our competitor's.
                        fourthCards[card].querySelector("img").src = `/assets/image/flags/1x1/${leaderboardData[competitor].countryCode.toLowerCase()}.svg`
                        fourthCards[card].querySelector(".competitor-name").innerHTML = leaderboardData[competitor].name;
                        fourthCardsMobile[card].querySelector("img").src = `/assets/image/flags/1x1/${leaderboardData[competitor].countryCode.toLowerCase()}.svg`
                        fourthCardsMobile[card].querySelector(".competitor-name").innerHTML = leaderboardData[competitor].name;
                    }
                }
            }

            //Fifth Column
            for (competitor = 0; competitor < leaderboardData.length; competitor++) {

                //Changing the card's position number, flag and name to our competitor's.
                if (leaderboardData[competitor].level0 === 1) {
                    winnerCard[0].querySelector("img").src = `/assets/image/flags/1x1/${leaderboardData[competitor].countryCode.toLowerCase()}.svg`
                    winnerCard[0].querySelector(".competitor-name").innerHTML = leaderboardData[competitor].name;
                    winnerCardMobile[1].querySelector("img").src = `/assets/image/flags/1x1/${leaderboardData[competitor].countryCode.toLowerCase()}.svg`;
                    winnerCardMobile[1].querySelector(".competitor-name").innerHTML = leaderboardData[competitor].name;
                }
            }

            //Getting all the cards in a collection except the winner
            var allCards = document.getElementsByClassName("competitor-card");

            //Here we are iterating through all the cards except the winner
            for (card = 0; card < allCards.length; card++) {

                //if we find a card that hasn't been filled yet, we are putting
                //on the empty-card class which contains specific css.
                if (allCards[card].querySelector(".competitor-name").innerHTML === "") {
                    allCards[card].classList.add("empty-card");
                }
            }

            //We are getting the winner cards
            winnerCard = document.getElementsByClassName("winner-card");

            //Here we are iterating through all the winner-cards
            for (card = 0; card < winnerCard.length; card++) {

                //if we find a winnerCard that hasn't been filled yet, we are putting
                //on the empty-winner class which contains specific css.
                if (winnerCard[card].querySelector(".competitor-name").innerHTML === "") {
                    winnerCard[card].classList.add("empty-winner");
                }
            }

        })

        .catch(function (error) {

            //Getting all the cards in a collection except the winner
            var allCards = document.getElementsByClassName("competitor-card");

            //Here we are iterating through all the cards except the winner
            for (var card = 0; card < allCards.length; card++) {

                //if we find a card that hasn't been filled yet, we are putting
                //on the empty-card class which contains specific css.
                if (allCards[card].querySelector(".competitor-name").innerHTML === "") {
                    allCards[card].classList.add("empty-card");
                }
            }

            //We are getting the winner card
            winnerCard = document.getElementsByClassName("winner-card");

            //Checking if winner card hasn't been filled yet.
            //If yes, then we are applying the special css class on it.
            //Here we are iterating through all the winner-cards
            for (card = 0; card < winnerCard.length; card++) {

                //if we find a winnerCard that hasn't been filled yet, we are putting
                //on the empty-winner class which contains specific css.
                if (winnerCard[card].querySelector(".competitor-name").innerHTML === "") {
                    winnerCard[card].classList.add("empty-winner");
                }
            }

    });
}
